import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/var/www/html/src/components/Layout/QuickStarts.tsx";
import Notification from 'components/Notification';
import NextSteps from 'components/Footer/NextSteps';
import Questions from 'components/Footer/Questions';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Send a Verification Token`}</h1>
    <p>{`In this Verify API Quickstart, you'll learn how to send your first verification token from your web application using the MessageBird Verify API.`}</p>
    <h2>{`Step 1: Set up your test environment`}</h2>
    <p>{`To start testing with the official Java SDK for MessageBird’s Verify API, you need to first set up your test environment.`}</p>
    <p>{`The following command will install MessageBird:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`git clone https://github.com/messagebird/java-rest-api
cd java-rest-api/api
mvn install
`}</code></pre>
    <Notification type="INFO" mdxType="Notification">
Want to learn how to set up your Java development environment? Check out the <a href="tutorials/setup-local-dev-environment-java">Java tutorial</a>
    </Notification>
    <h2>{`Step 2: Send your first verification token`}</h2>
    <p>{`Next, enter `}<a parentName="p" {...{
        "href": "https://dashboard.messagebird.com/en/developers/access"
      }}>{`your credentials`}</a>{` and mobile number - as both the `}<inlineCode parentName="p">{`originator`}</inlineCode>{` and `}<inlineCode parentName="p">{`recipient`}</inlineCode>{` - to the snippet below and copy it to your IDE.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`VerifyRequest request = new VerifyRequest("recipient");
request.setOriginator("YourName");

Verify verify = messageBirdClient.sendVerifyToken(request);
`}</code></pre>
    <Notification type="INFO" mdxType="Notification">
You can access and manage your credentials in the <a href="https://dashboard.messagebird.com/en/developers/access">MessageBird Developer Dashboard</a>.
    </Notification>
    <p>{`Now, run the application from your IDE.`}</p>
    <p>{`Good job! You’ve sent your first verification token with the official Java SDK for MessageBird’s Verify API.`}</p>
    <h2>{`Step 3: View the response`}</h2>
    <p>{`Now, let’s view MessageBird’s HTTP response to your API call. If the set up was correct, you'll receive a response similar to this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`com.messagebird.objects.Verify@4450d156[
id=4e213b01155d1e35a9d9571v00162985
href=https://rest.messagebird.com/verify/4e213b01155d1e35a9d9571v00162985
recipient=31XXXXXXXXX
messages=Messages{href=https://rest.messagebird.com/messages/31bce2a1155d1f7c1db9df6b32167259}
status=sent
createdDatetime=Tue May 03 20:12:54 CEST 2016
validUntilDatetime=Tue May 03 20:13:24 CEST 2016
    ]
`}</code></pre>
    <p>{`If something went wrong, you’ll receive an error response from the MessageBird API. Don't worry, simply head over to `}<a parentName="p" {...{
        "href": "/docs/verify/troubleshooting"
      }}>{`Verify API Troubleshooting`}</a>{` to understand the error.`}</p>
    <p>{`Congrats! You can now programmatically send a verification token with the MessageBird Verify API using Java.`}</p>
    <NextSteps intro="You may now want to check out these resources:" steps={[{
      name: 'Verify a token via the API',
      to: '/quickstarts/verify/verify-a-token-java'
    }, {
      name: 'Verify Tutorials',
      to: '/tutorials?filter=verify'
    }, {
      name: 'Verify API Reference',
      to: '/api/verify'
    }]} mdxType="NextSteps" />
    <Questions mdxType="Questions" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      